import { useMemo } from 'react';

import { defineMessage, useIntl } from 'react-intl';

import { useProductData, ProductCategory, Treatment } from '../../global-nav-products-dropdown';
import { NUM_DISPLAY_NEW_PRODUCTS } from '../common/constants';

import { ProductsGrid } from './products-grid';

const title = defineMessage({
	id: 'globalnav.v2.products.featured.new',
	defaultMessage: 'New products',
});

type NewProductsContainerProps = {
	excludedProducts: string[];
	isMobile: boolean;
};

export const NewProductsContainer = ({ excludedProducts, isMobile }: NewProductsContainerProps) => {
	const { formatMessage } = useIntl();

	const { productsByTag } = useProductData();

	const products = useMemo(
		() =>
			productsByTag[ProductCategory.Featured]
				.filter((product) => product.treatment === Treatment.New)
				.filter(({ id }) => !excludedProducts.includes(id))
				.slice(0, NUM_DISPLAY_NEW_PRODUCTS),
		[productsByTag, excludedProducts],
	);

	if (products.length === 0) {
		return null;
	}

	return (
		<ProductsGrid
			products={products}
			title={formatMessage(title)}
			isMobile={isMobile}
			container={'NewProductsContainer'}
		/>
	);
};
